import React from 'react';
import Link from 'next/link';
import AutoScroll from 'embla-carousel-auto-scroll';
import { cn } from '@/utils/styles';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '../shadcn/carousel/carousel';
import { Card } from '../shadcn/card';
import { P } from '../shadcn/typography';

export interface SocialMediaPost {
  id: string;
  content: string;
  author: string;
  authorTag: string;
  url: string;
}

interface SocialPostCarouselProps {
  posts: SocialMediaPost[];
  className?: string;
  contentClassName?: string;
  direction?: 'left' | 'right';
}

const directionMap = {
  left: 'forward',
  right: 'backward',
};

const SocialPostCarousel = ({
  posts,
  className,
  contentClassName,
  direction = 'left',
}: SocialPostCarouselProps) => {
  return (
    <Carousel
      showMasks
      className={cn('h-full w-full', className)}
      plugins={[
        AutoScroll({
          speed: 0.5,
          direction: directionMap[direction] as 'forward' | 'backward',
          stopOnInteraction: false,
        }),
      ]}
      opts={{
        loop: true,
      }}>
      <CarouselContent
        dir={directionMap[direction]}
        className={cn(
          '-ml-0 h-[180px] w-full items-stretch sm:h-[180px]',
          contentClassName,
        )}>
        {[...posts, ...posts].map((post, index) => (
          <CarouselItem
            key={post.id + index}
            className="h-full basis-full flex-col pl-6 md:basis-1/2 lg:basis-1/3 xl:basis-1/4">
            <Card className="flex h-full flex-col justify-between gap-3 p-6">
              <P className="grow text-left text-xs text-neutral-300 md:text-sm">
                {post.content}
              </P>
              <div className="flex items-center gap-1">
                <P className="!text-2xs font-bold">{post.author}</P>
                <Link href={post.url} target="_blank" rel="noopener noreferrer">
                  <P className="!text-2xs text-neutral-500 hover:underline">
                    {post.authorTag}
                  </P>
                </Link>
              </div>
            </Card>
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};

export default SocialPostCarousel;
